module.exports = __webpack_public_path__ + "img/dabiao_0000_1.83b086ca.png";